import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { OrderStatus } from 'src/app/core/orders.service';
import { ListUnpaidParams, UnpaidStatus } from 'src/app/core/unpaid.service';
import { UtilsService } from 'src/app/core/utils.service';
import {
  APPROVED_LABEL,
  BUYER_COLUMN_LABEL,
  COMPANY_LABEL,
  FORM_CREATED_FROM_FIELD_LABEL,
  FORM_CREATED_TO_FIELD_LABEL,
  FORM_DUE_DATE_FROM_FIELD_LABEL,
  FORM_DUE_DATE_TO_FIELD_LABEL,
  FORM_ORDER_ID_FIELD_LABEL,
  FORM_STATUS_FIELD_LABEL,
  FORM_STEP_ID_FIELD_LABEL,
  QINETIC_ID_LABEL,
  STORE_NAME_LABEL,
  UNPAID_DAYS_LABEL,
  UNPAID_LABEL,
} from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-unpaid-filters',
  templateUrl: './unpaid-filters.component.html',
  styleUrls: ['./unpaid-filters.component.scss'],
})
export class UnpaidFiltersComponent {
  @Input() filters?: ListUnpaidParams;
  @Output() filter_clear: EventEmitter<ListUnpaidParams> = new EventEmitter<ListUnpaidParams>();

  constructor(private date_pipe: DatePipe, private utils_service: UtilsService) {}

  onFilterClear(key: string): void {
    if (this.filters) {
      this.filters[key as keyof typeof this.filters] = undefined;
      this.filter_clear.emit(this.filters);
    }
  }

  getFiltersKeys(): string[] {
    if (this.filters) {
      return Object.keys(this.filters).filter(k => {
        return this.isKeySet(k);
      });
    }

    return [];
  }

  getOrderStatusLabel(status?: OrderStatus): string {
    if (!status) return '';
    return status?.replace(',running', '');
  }

  isKeySet(key: string): boolean {
    if (!this.filters) return false;
    return this.utils_service.isFilterUnpaidKeySet(this.filters, key);
  }

  getLabelByKey(key: string): string {
    switch (key) {
      case 'order_id':
        return FORM_ORDER_ID_FIELD_LABEL;

      case 'step_id':
        return FORM_STEP_ID_FIELD_LABEL;

      case 'status':
        return FORM_STATUS_FIELD_LABEL;

      case 'created_from':
        return FORM_CREATED_FROM_FIELD_LABEL;

      case 'created_to':
        return FORM_CREATED_TO_FIELD_LABEL;

      case 'due_date_from':
        return FORM_DUE_DATE_FROM_FIELD_LABEL;

      case 'due_date_to':
        return FORM_DUE_DATE_TO_FIELD_LABEL;

      case 'qinetic_id':
        return QINETIC_ID_LABEL;

      case 'unpaid_days':
        return UNPAID_DAYS_LABEL;

      case 'unsolved':
        return UNPAID_LABEL;

      case 'buyer_name':
        return BUYER_COLUMN_LABEL;

      case 'store_name':
        return STORE_NAME_LABEL;

      case 'company_name':
        return COMPANY_LABEL;

      default:
        return '';
    }
  }

  getContentByKey(key: string): string {
    switch (key) {
      case 'order_id':
        return this.filters?.order_id || '-';

      case 'step_id':
        return this.filters?.step_id || '-';

      case 'created_from':
        return this.toStringDate(this.filters?.created_from || 0);

      case 'created_to':
        return this.toStringDate(this.filters?.created_to || 0);

      case 'due_date_from':
        return this.toStringDate(this.filters?.due_date_from || 0);

      case 'due_date_to':
        return this.toStringDate(this.filters?.due_date_to || 0);

      case 'status':
        return this.filters?.status ? this.filters?.status : '';

      case 'qinetic_id':
        return this.filters?.qinetic_id || '-';

      case 'unpaid_days':
        return this.filters?.unpaid_days || '-';

      case 'unsolved':
        return this.filters?.unsolved || '-';

      case 'store_name':
        return this.filters?.store_name || '-';

      case 'company_name':
        return this.filters?.company_name || '-';

      case 'buyer_name':
        return this.filters?.buyer_name || '-';

      default:
        return '';
    }
  }

  toStringDate(date: number): string {
    return this.date_pipe.transform(date, 'shortDate') || '-';
  }
}
